export const scaleImageUrl = (
  url: string | undefined,
  width: number,
  height: number
): string => {
  // Fallback to static image if URL is undefined, empty, or not a string
  if (!url || typeof url !== "string") {
    return "/assets/images/placeholder_image.webp";
  }

  try {
    const dimensionRegex = /\/r\d+x\d+\//i;
    const defaultDimensionRegex = /\/i\d+\.\d+\//i;

    let newWidth = width;
    let newHeight = height;

    if (newWidth === 0 || newHeight === 0) {
      const defaultDimensionMatch = url.match(defaultDimensionRegex);
      if (defaultDimensionMatch) {
        const defaultDimensionString = defaultDimensionMatch[0]
          .replace("/i", "")
          .replace("/", "");
        const [defaultWidth, defaultHeight] = defaultDimensionString
          .split(".")
          .map(Number);

        if (newWidth === 0) newWidth = defaultWidth || 0;
        if (newHeight === 0) newHeight = defaultHeight || 0;
      }
    }

    // Ensure minimum dimensions of 1px to avoid invalid URLs
    newWidth = Math.max(1, newWidth);
    newHeight = Math.max(1, newHeight);

    // Replace existing dimension or add new one
    if (dimensionRegex.test(url)) {
      return url.replace(dimensionRegex, `/r${newWidth}x${newHeight}/`);
    } else {
      // Insert dimensions after domain
      const domainEnd = url.indexOf("//") + 2;
      const pathStart = url.indexOf("/", domainEnd);

      // Additional safety check for URL structure
      if (domainEnd < 2 || pathStart === -1) {
        return "/assets/images/placeholder_image.webp";
      }

      return `${url.substring(
        0,
        pathStart
      )}/r${newWidth}x${newHeight}${url.substring(pathStart)}`;
    }
  } catch (error) {
    console.error("Error scaling image URL:", error);
    return "/assets/images/placeholder_image.webp";
  }
};

// export const scaleImageUrl = (
//   url: string,
//   width: number,
//   height: number
// ): string => {
//   const dimensionRegex = /\/r\d+x\d+\//i;
//   const defaultDimensionRegex = /\/i\d+\.\d+\//i;

//   let newWidth = width;
//   let newHeight = height;

//   if (newWidth === 0 || newHeight === 0) {
//     const defaultDimensionMatch = url.match(defaultDimensionRegex);
//     if (defaultDimensionMatch) {
//       const defaultDimensionString = defaultDimensionMatch[0]
//         .replace("/i", "")
//         .replace("/", "");
//       const [defaultWidth, defaultHeight] = defaultDimensionString
//         .split(".")
//         .map(Number);

//       if (newWidth === 0) newWidth = defaultWidth || 0;
//       if (newHeight === 0) newHeight = defaultHeight || 0;
//     }
//   }

//   // Replace existing dimension or add new one
//   if (dimensionRegex.test(url)) {
//     return url.replace(dimensionRegex, `/r${newWidth}x${newHeight}/`);
//   } else {
//     // Insert dimensions after domain
//     const domainEnd = url.indexOf("//") + 2;
//     const pathStart = url.indexOf("/", domainEnd);
//     return `${url.substring(
//       0,
//       pathStart
//     )}/r${newWidth}x${newHeight}${url.substring(pathStart)}`;
//   }
// };
